import {
  ChangeDetectorRef,
  ChangeDetectionStrategy,
  Component,
  OnInit,
  EventEmitter,
  Inject,
  Injectable,
  Input,
  LOCALE_ID,
  OnChanges,
  Output,
  SimpleChanges,
  ElementRef
} from '@angular/core';
import { CalendarUtils, CalendarWeekViewComponent, DateAdapter, getWeekViewPeriod } from 'angular-calendar';
import { WeekView, GetWeekViewArgs, WeekViewTimeEvent, EventColor, CalendarEvent } from 'calendar-utils';
import { DragEndEvent, DragMoveEvent } from 'angular-draggable-droppable';
import { Subject } from 'rxjs';
import { Router } from '@angular/router';
import { DialogService } from 'primeng/dynamicdialog';
import { DateFormatModel } from 'src/app/shared/models/common/date-format-model';
import { WebStorageService } from 'src/app/shared/services/web-storage.service';
import { AdminTherapistService } from 'src/app/admin/servicies/admin-therapist.service';
import moment from 'moment';
import 'moment-timezone';
import { isSameDay, isBefore, isAfter } from 'date-fns';
import {
  AppointmentInfoReponseModel,
  TherapistCustomDatesResponseModel
} from 'src/app/shared/models/response/appointment/appointment-info-reponse-model';
import { OverlayPanel } from 'primeng/overlaypanel';
import { finalize, takeUntil } from 'rxjs/operators';
import { ResultOfT } from 'src/app/shared/models/response/result';
import * as _ from 'lodash';
import { TimeZoneAvailableResponseModel } from 'src/app/shared/models/response/time-zone-available-response-model';
import { AuthenticationService } from 'src/app/shared/services/authentication.service';

export class User {
  id: number;
  practionaerId: number;
  deliveryTechnicianId: number;
  name: string;
  field: string;
  start: Date;
  end: Date;
  origStart: Date;
  origEnd: Date;
  startDate: Date;
  endDate: Date;
  color: EventColor;
  isChecked: boolean;
  facilityTimeZone: string;
  remoteAppointmentType: string;
  therapistAvailability: TherapistCustomDatesResponseModel[];
  distinctTherapistAvailability: TherapistCustomDatesResponseModel[];
  therapistCustomAvailabilityId: number;
  customDatesId: number;
  therapistCustomDateId: number;
  enUserInfoId: string;
  isGroupAppointmentUser?: boolean;
}

export class TimeZones {
  name: string;
  code: string;
}
export interface GroupPatientOption {
  name: string;
  appointmentGroupId: string;
  appointmentId: any;
  event: any;
}

interface DayViewScheduler extends WeekView {
  users: User[];
}
interface GetWeekViewArgsWithUsers extends GetWeekViewArgs {
  users: User[];
}



@Injectable()
export class DayViewSchedulerCalendarUtils extends CalendarUtils {
  menuopen = false;
  menuOpenEvent() { this.menuopen = !this.menuopen; }

  getWeekView(args: GetWeekViewArgsWithUsers): DayViewScheduler {
    const { period } = super.getWeekView(args);
    const view: DayViewScheduler = { period, allDayEventRows: [], hourColumns: [], users: [...args.users] };

    view.users.forEach((user, columnIndex) => {
      const events = args.events.filter((e) => e.meta.appointmentInfoReponseModel.field === user.field);
      const columnView = super.getWeekView({ ...args, events });
      view.hourColumns.push(columnView.hourColumns[0]);
      columnView.allDayEventRows.forEach(({ row }, rowIndex) => {
        view.allDayEventRows[rowIndex] = view.allDayEventRows[rowIndex] || { row: [] };
        view.allDayEventRows[rowIndex].row.push({ ...row[0], offset: columnIndex, span: 1 });
      });
    });
    return view;
  }
}

@Component({
  selector: 'app-day-view-scheduler-v1',
  templateUrl: './day-view-scheduler-v1.component.html',
  styleUrls: ['./day-view-scheduler-v1.component.sass'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [DayViewSchedulerCalendarUtils, DialogService],
  standalone: false
})
export class DayViewSchedulerV1Component extends CalendarWeekViewComponent implements OnChanges {

  private unsubscriber = new Subject<boolean>();
  title = 'Calendars';

  @Input() users: User[] = [];
  @Input() events: CalendarEvent[] = [];
  @Input() patientBrighttreeURL: string;
  @Input() salesOrderBrighttreeURL: string;
  @Input() refresh: Subject<any> = new Subject();
  @Input() dayStartHour: number;
  @Input() dayEndHour: number;
  @Input() hourSegments: number;
  @Input() hourSegmentHeight: number;
  @Input() selectedAppointment: number[];
  @Input() selectedRowAppointment: string[];
  @Input() timeZoneCode: string;

  @Output() userChanged = new EventEmitter();
  @Output() popupCalled = new EventEmitter();
  @Output() PhonecallBackCalled = new EventEmitter();
  @Output() HangUpCallBackCalled = new EventEmitter();
  @Output() selectedAppoinmentCalled = new EventEmitter();
  @Output() hourSegmentClickedOverrited = new EventEmitter();
  @Output() selectedRowAppoinmentCalled = new EventEmitter();
  @Output() removeSlotCalled = new EventEmitter();
  @Output() editSlotCalled = new EventEmitter();
  @Output() removeBreakCalled = new EventEmitter();
  @Output() editBreakCalled = new EventEmitter();
  @Output() ontimeZoneChange = new EventEmitter<string>();
  @Output() groupPatientSelected = new EventEmitter<{ groupId: string, appointmentId: any }>();

  loading = false;
  calendarWidth = 221;
  appDateFormat: DateFormatModel;
  viewDate: Date = new Date();
  view: DayViewScheduler;
  availModel: TherapistCustomDatesResponseModel[];
  therapistName: string;
  brightreeInternalUserId: number;
  daysInWeek = 1;
  currentDate: Date;
  timeZoneList: TimeZoneAvailableResponseModel[];
  facilitySelect: { name: string; code: string }[];
  SelectedAppointments: AppointmentInfoReponseModel[];
  selfGuidedText = 'SelfGuided'.toLowerCase();
  activeDayIsOpen = true;

  timeZone: { name: string; code: string; orgcode: string; shortName: string; displayName: string; countryName: string }[];
  selectedTimeZone: { name: string; code: string; orgcode: string; shortName: string; displayName: string; countryName: string };
  slotTimeZone: { name: string; code: string; shortName: string; displayName: string; countryName: string };

  patientSelect: GroupPatientOption[] = [];
  selectedPatientPerGroup: Map<string, GroupPatientOption> = new Map();
  bookedGroupAppointmentType: string = '';
  isGroupAppointmentFeatureSubscribed = false;
  isGroupAppointment(event: any): boolean {

    return event?.meta?.user?.isGroupAppointmentUser && event?.meta?.appointmentInfoReponseModel?.appointment?.appointmentGroupId != null;
    // if (event?.appointmentGroupId == null) return false;
    // return true;

    //return this.getGroupPatients(String(event.appointmentGroupId)).length > 1;
  }

  getGroupPatients(appointmentGroupId: string): GroupPatientOption[] {
    return this.patientSelect.filter(
      (x) => String(x.appointmentGroupId) === String(appointmentGroupId)
    );
  }

  getActiveBookedBy(event: any): number {
    if (this.isGroupAppointment(event)) {
      const selectedOption = this.getSelectedPatientOption(event.appointmentGroupId);
      if (selectedOption && selectedOption.event.meta.appointmentInfoReponseModel.appointment.schAppointmentBookedBy !== undefined) {
        return selectedOption.event.meta.appointmentInfoReponseModel.appointment.schAppointmentBookedBy;
      }
    }
    return event.meta?.appointmentInfoReponseModel?.appointment?.schAppointmentBookedBy;
  }

  getSelectedPatientOption(appointmentGroupId: string): GroupPatientOption | null {
    const key = String(appointmentGroupId);
    const stored = this.selectedPatientPerGroup.get(key);
    if (stored) {
      this.selectedPatientPerGroup.set(key, stored);
      this.groupPatientSelected.emit({ groupId: key, appointmentId: stored.appointmentId });
      return stored;
    }

    const first = this.getGroupPatients(key)[0] ?? null;
    if (first) {
      this.selectedPatientPerGroup.set(key, first);
      this.groupPatientSelected.emit({ groupId: key, appointmentId: first.appointmentId });
    }
    return first;
  }

  onGroupPatientChange(option: GroupPatientOption, appointmentGroupId: string): void {
    if (!option) return;
    this.selectedPatientPerGroup.set(String(appointmentGroupId), option);
    this.groupPatientSelected.emit({ groupId: String(appointmentGroupId), appointmentId: option.appointmentId });

    const groupEvent = this.events.find((e: any) => String(e.appointmentGroupId) === String(appointmentGroupId));
    const therapistField = groupEvent?.meta?.appointmentInfoReponseModel?.field;

    const groupEventIds = this.events
      .filter((e: any) => String(e.appointmentGroupId) === String(appointmentGroupId))
      .map(e => e.id.toString());

    groupEventIds.forEach(id => {
      this.selectedRowAppointment = this.selectedRowAppointment.filter(x => x !== id);
    });

    this.SelectedAppointments = (this.SelectedAppointments || []).filter(
      a => String(a.appointmentGroupId) !== String(appointmentGroupId)
    );

    if (therapistField) {
      const user = this.users.find(u => u.field === therapistField);
      if (user) {
        user.isChecked = false;
      }
    }

    const selectedUser = this.users.find(u => u.field === therapistField) ?? new User();
    this.selectedAppoinmentCalled.emit({
      checked: false,
      selectedUser,
      selectedAppoinment: this.selectedRowAppointment,
      selectedAppointmentsInformation: this.SelectedAppointments
    });

    this.cdr.markForCheck();
  }


  getActiveEvent(event: any): any {
    if (!this.isGroupAppointment(event)) return event;
    return this.getSelectedPatientOption(String(event.appointmentGroupId))?.event ?? event;
  }


  getActiveAppointment(event: any): any {
    return this.getActiveEvent(event)?.meta?.appointmentInfoReponseModel?.appointment
      ?? event?.meta?.appointmentInfoReponseModel?.appointment;
  }


  getActiveAppointmentType(event: any): string {
    return this.getActiveAppointment(event)?.crmAppointmentType
      ?? event?.meta?.appointmentInfoReponseModel?.appointment?.crmAppointmentType
      ?? '';
  }


  getActiveClassification(event: any): string {
    return this.getActiveAppointment(event)?.classificationDisplayName
      ?? event?.meta?.appointmentInfoReponseModel?.appointment?.classificationDisplayName
      ?? '';
  }


  getActiveStartLabel(event: any): any {
    return this.getActiveEvent(event)?.startLabel ?? event?.startLabel;
  }

  getActiveEndLabel(event: any): any {
    return this.getActiveEvent(event)?.endLabel ?? event?.endLabel;
  }


  getActivePatientTimeZone(event: any): string {
    const tz = this.getActiveEvent(event)?.crmPatientTimeZone;
    if (tz && tz !== 'null') return tz;
    return event?.crmPatientTimeZone ?? '';
  }


  getActivePatientName(event: any): string {
    return this.getActiveEvent(event)?.title ?? event?.title ?? '';
  }


  getActiveFacilityName(event: any): string {
    return this.getActiveAppointment(event)?.crmFacilityName
      ?? event?.meta?.appointmentInfoReponseModel?.appointment?.crmFacilityName
      ?? '';
  }

  getActivePatientAddress(event: any): string {
    const bookedAddress = this.getActiveFacilityName(event);
    if (bookedAddress) return bookedAddress;
    const appt = this.getActiveAppointment(event);
    return appt?.salesOrderInfo?.patientInfo?.crmPatientAddress ?? '';
  }


  getActiveSalesOrderAppId(event: any): string {
    return this.getActiveAppointment(event)?.crmSalesorderAppId ?? '';
  }


  getActivePatientRcmId(event: any): string {
    return this.getActiveAppointment(event)?.crmPatientRcmBrightreeID ?? '';
  }


  getActivePatientId(event: any): string {
    return this.getActiveAppointment(event)?.crmPatientId ?? '';
  }

  // ── Dots-button handler ────────────────────────────────────────────────────

  showDialogPopup(appointment: any): void {
    this.popupCalled.emit({ isShow: true, appointment });
  }

  /**
   * Called by the ⋯ dots button.
   * Group → resolves the ACTIVE patient's appointment before emitting.
   * Individual → identical to original behaviour.
   */

  showDialogPopupForEvent(event: any): void {
    let startDate = moment(event.start).toDate();
    //let isGroupAppointment = this.isGroupAppointment(event)

    this.bookedGroupAppointmentType = this.getActiveAppointmentType(event);
    let facilityInfo: TherapistCustomDatesResponseModel = event?.meta?.user?.distinctTherapistAvailability.find(
      (x) => startDate >= moment(x.crmStartTime).add(-1, 'minutes').toDate()
        && startDate <= moment(x.crmEndTime).add(-1, 'minutes').toDate());


    const appointment = this.getActiveAppointment(event);
    this.popupCalled.emit({ isShow: true, appointment, isGroupAppointment: event?.meta?.user?.isGroupAppointmentUser && event?.meta?.appointmentInfoReponseModel?.appointment?.appointmentGroupId != null, facilityInfo: facilityInfo, bookedGroupAppointmentType: this.bookedGroupAppointmentType });
  }

  addToSelectedAppointment(isChecked: any, value: any) {
    const evnt = this.events.filter((x) => x.meta.appointmentInfoReponseModel.field === value.meta.appointmentInfoReponseModel.field && x.id != 0);
    const evnt1 = this.events.filter((x) => x.meta.appointmentInfoReponseModel.field !== value.meta.appointmentInfoReponseModel.field && x.id != 0);

    evnt1.forEach((valueItem) => {
      if (this.selectedRowAppointment.find((x) => x === valueItem.id.toString())) {
        this.selectedRowAppointment = this.selectedRowAppointment.filter((x) => x !== valueItem.id.toString());
      }
    });

    this.users.forEach((v) => {
      v.isChecked = false;
      if (this.selectedRowAppointment.length == evnt.length && v.id == value.meta.appointmentInfoReponseModel.field) {
        v.isChecked = true;
      }
    });

    this.SelectedAppointments = [];
    const processedGroupIds = new Set<string>();

    this.selectedRowAppointment.forEach((appt) => {
      const appts = this.events.find((x) => x.id == appt);
      if (appts) {
        const groupId = (appts as any).appointmentGroupId ?? appts.meta?.appointmentInfoReponseModel?.appointment?.appointmentGroupId;

        if (groupId) {
          const groupKey = String(groupId);
          if (processedGroupIds.has(groupKey)) return;
          processedGroupIds.add(groupKey);

          const selectedOption = this.getSelectedPatientOption(groupKey);
          if (selectedOption?.event?.meta?.appointmentInfoReponseModel?.appointment) {
            const appointment = selectedOption.event.meta.appointmentInfoReponseModel.appointment;
            if (!appointment.appointmentGroupId) {
              appointment.appointmentGroupId = groupId;
            }
            this.SelectedAppointments.push(appointment);
          }
        } else {
          const appointment = appts.meta.appointmentInfoReponseModel.appointment;
          if (appointment) this.SelectedAppointments.push(appointment);
        }
      }
    });

    const selectedUser = this.users.find((x) => x.id == value.meta.appointmentInfoReponseModel.field) ?? new User();
    this.SelectedAppointments = this.sortData();
    this.selectedAppoinmentCalled.emit({
      checked: isChecked,
      selectedUser,
      selectedAppoinment: this.selectedRowAppointment,
      selectedAppointmentsInformation: this.SelectedAppointments
    });
  }

  addToSelectedHeader(isChecked: any, value: any, therpaistId: any) {
    this.selectedRowAppointment = [];
    const evnt = this.events.filter((x) => x.meta.appointmentInfoReponseModel.field === value);
    if (isChecked.checked) {
      evnt.forEach((val) => { if (val.id != 0 && val.id != -1) this.selectedRowAppointment.push(val.id.toString()); });
    }
    const unique = this.selectedRowAppointment.filter((e, i, s) => i === s.indexOf(e));

    this.users.forEach((v) => {
      v.isChecked = false;
      if (v.id == therpaistId) v.isChecked = true;
    });

    this.selectedRowAppointment = unique;
    this.refreshAll();

    this.SelectedAppointments = [];
    const processedGroupIds = new Set<string>();

    this.selectedRowAppointment.forEach((appt) => {
      const appts = this.events.find((x) => x.id == appt);
      if (appts) {
        const groupId = (appts as any).appointmentGroupId ?? appts.meta?.appointmentInfoReponseModel?.appointment?.appointmentGroupId;

        // For group appointments, only process once per group and use dropdown-selected patient
        if (groupId) {
          const groupKey = String(groupId);
          if (processedGroupIds.has(groupKey)) return;
          processedGroupIds.add(groupKey);

          const selectedOption = this.getSelectedPatientOption(groupKey);
          if (selectedOption?.event?.meta?.appointmentInfoReponseModel?.appointment) {
            const appointment = selectedOption.event.meta.appointmentInfoReponseModel.appointment;
            if (!appointment.appointmentGroupId) {
              appointment.appointmentGroupId = groupId;
            }
            this.SelectedAppointments.push(appointment);
          }
        } else {
          const appointment = appts.meta.appointmentInfoReponseModel.appointment;
          if (appointment) this.SelectedAppointments.push(appointment);
        }
      }
    });
    this.SelectedAppointments = this.sortData();

    const selectedUser = this.users.find((x) => x.id == therpaistId) ?? new User();
    this.selectedAppoinmentCalled.emit({
      checked: isChecked,
      selectedUser,
      selectedAppoinment: this.selectedRowAppointment,
      selectedAppointmentsInformation: this.SelectedAppointments
    });
  }

  sortData() {
    return this.SelectedAppointments.sort(
      (a, b) => <any>new Date(a.schAppointmentDateStartTime) - <any>new Date(b.schAppointmentDateStartTime)
    );
  }


  constructor(
    private router: Router,
    protected cdr: ChangeDetectorRef,
    protected utils: DayViewSchedulerCalendarUtils,
    @Inject(LOCALE_ID) locale: string,
    protected dateAdapter: DateAdapter,
    private dialougeService: DialogService,
    private webStorageService: WebStorageService,
    private therapistService: AdminTherapistService,
    private authenticationService: AuthenticationService,
    protected elementRef: ElementRef<HTMLElement>
  ) {
    super(cdr, utils, locale, dateAdapter, elementRef);
    this.appDateFormat = this.webStorageService.getDateFormat();
    this.timeZone = [
      { name: 'Eastern Time (UTC -5:00)', code: 'UTC -5', orgcode: 'UTC-5', shortName: 'EST', displayName: 'EST', countryName: 'America/New_York' },
      { name: 'Central Time (UTC -6:00)', code: 'UTC -6', orgcode: 'UTC-6', shortName: 'CST', displayName: 'Central', countryName: 'America/Chicago' },
      { name: 'Mountain Time (UTC -7:00)', code: 'UTC -7', orgcode: 'UTC-7', shortName: 'MST', displayName: 'Mountain', countryName: 'America/Boise' },
      { name: 'Arizona Mountain Time (UTC-7:00)', code: 'UMST -7', orgcode: 'UMST-7', shortName: 'AMST', displayName: 'Mountain', countryName: 'America/Phoenix' },
      { name: 'Pacific Time (UTC -8:00)', code: 'UTC -8', orgcode: 'UTC-8', shortName: 'PST', displayName: 'Pacific', countryName: 'America/Los_Angeles' },
      { name: 'Hawaiian Standard Time (UTC -10:00)', code: 'UTC -10', orgcode: 'UTC-10', shortName: 'HST', displayName: 'Hawaiian', countryName: 'Pacific/Honolulu' }

    ];
    this.selectedTimeZone = this.timeZone.find((x) => x.code === this.appDateFormat.timeZone);
    const date = moment(new Date()).tz(this.selectedTimeZone.countryName).format('DD-MMM-yyyy hh:mm:ss');
    this.currentDate = moment(date).toDate();
    const loggedInUser = this.webStorageService.getCurrentUserToken();
    this.brightreeInternalUserId = loggedInUser.crmBrightreeUserId;
    this.facilitySelect = [{ name: 'facility', code: 'FC' }, { name: 'Online Meeting', code: 'OM' }];
    this.webStorageService.getClientConfig();
    
    const clientConfig = this.webStorageService.getClientConfig();
    if (clientConfig) {
      this.isGroupAppointmentFeatureSubscribed = clientConfig.isGroupAppointment
        ? clientConfig.isGroupAppointment
        : false;
    }
  }


  ngOnInit() {
    this.timeZoneList = this.webStorageService.getTimeZoneList();
  }

  ngOnChanges(changes: SimpleChanges): void {
    super.ngOnChanges(changes);

    if (changes.events?.currentValue) {
      this.SelectedAppointments = [];
      this.selectedRowAppointment = [];

      this.patientSelect = [];

      const allEvents: any[] = changes.events.currentValue;

      const grouped = _.groupBy(
        allEvents.filter((e: any) => e.appointmentGroupId != null),
        (e: any) => String(e.appointmentGroupId)
      );

      for (const key of Object.keys(grouped)) {
        const groupEvents = grouped[key];

        groupEvents.forEach((evt: any) => {
          this.patientSelect.push({
            name: evt.title,
            appointmentGroupId: String(evt.appointmentGroupId),
            appointmentId: evt.id,
            event: evt
          });
        });

        if (!this.selectedPatientPerGroup.has(key)) {
          const defaultOption = this.patientSelect.find(
            (o) => String(o.appointmentGroupId) === key && o.appointmentId === groupEvents[0].id
          );
          if (defaultOption) {
            this.selectedPatientPerGroup.set(key, defaultOption);
          }
        }
      }

      this.selectedPatientPerGroup.forEach((storedOption, key) => {
        const updatedOption = this.patientSelect.find(
          o => String(o.appointmentGroupId) === key && o.appointmentId === storedOption.appointmentId
        );
        if (updatedOption) {
          this.selectedPatientPerGroup.set(key, updatedOption);
        } else {
          this.selectedPatientPerGroup.delete(key);
        }
      });
    }

    if (changes.users) {
      (changes.users.currentValue as User[] ?? []).forEach(u => (u.isChecked = false));
      this.refreshBody();
      this.emitBeforeViewRender();
    }
  }

  onTimeZoneSelection(timezone: string) { this.ontimeZoneChange.emit(timezone); }

  idDateIsPassed(segmentdate: any, user: any) {
    this.slotTimeZone = this.timeZone.find((x) => x.shortName === this.timeZoneCode);
    const datec = moment(new Date()).tz(this.slotTimeZone.countryName).format('DD-MMM-yyyy HH:mm:ss');
    const currentDate = moment(datec).toDate();
    const date = moment(segmentdate).toDate();
    const startDate = moment(user.start).toDate();
    const endDate = moment(user.end).toDate();
    if (isBefore(segmentdate, currentDate)) return false;
    if ((isSameDay(segmentdate, currentDate) || isAfter(segmentdate, currentDate)) && date >= startDate && date <= endDate) return true;
    return false;
  }

  isFutureDate(date: Date): boolean {
    return moment(date).startOf('day').isSameOrAfter(moment().startOf('day'));
  }

  GetAvailability(id: any, event: any, overlaypanel: OverlayPanel, name: string) {
    const selectedDate =
      `${this.viewDate.getFullYear()}-${this.viewDate.getMonth() + 1}-${this.viewDate.getDate()}`;
    this.therapistService
      .GetAvailData(id, selectedDate)
      .pipe(takeUntil(this.unsubscriber), finalize(() => (this.loading = false)))
      .subscribe(
        (result: ResultOfT<TherapistCustomDatesResponseModel[]>) => {
          this.processResult<TherapistCustomDatesResponseModel[]>(result, () => {
            this.availModel = result?.responseModel?.length ? result.responseModel : null;
            this.therapistName = name;
            this.cdr.detectChanges();
          });
        },
        () => { }
      );
    overlaypanel.toggle(event);
    this.cdr.detectChanges();
  }

  hourSegmentClickedOverrite(date: Date, sourceEvent: any, userinfo: User) {
    this.hourSegmentClickedOverrited.emit({ date, sourceEvent, userinfo });
  }

  facilityNameLabel(slotStartTime: Date, therapistAvailability: TherapistCustomDatesResponseModel[]): string {
    if (!therapistAvailability) return '';
    const startDate = moment(slotStartTime).toDate();
    const facility = therapistAvailability.find(
      (x) =>
        startDate >= moment(x.crmStartTime).add(-1, 'minutes').toDate() &&
        startDate <= moment(x.crmEndTime).add(-1, 'minutes').toDate()
    );
    if (!facility) return '';
    return facility.isRemoteAndFacility
      ? `${facility.facilityName} & ${facility.remoteFacilityName}`
      : facility.facilityName;
  }

  removeSlot(therapistCustomAvailabilityId: number, availId: number, customDatesId: number) {
    this.removeSlotCalled.emit({ therapistCustomAvailabilityId, availId, customDatesId });
  }
  editSlot(therapistCustomAvailabilityId: number, availId: number, therapistCustomDateId: number) {
    this.editSlotCalled.emit({ therapistCustomAvailabilityId, availId, therapistCustomDateId });
  }
  removeBreak(therapistCustomAvailabilityId: number, availId: number, customDatesId: number) {
    this.removeBreakCalled.emit({ therapistCustomAvailabilityId, availId, customDatesId });
  }
  editBreak(therapistCustomAvailabilityId: number, availId: number, therapistCustomDateId: number) {
    this.editBreakCalled.emit({ therapistCustomAvailabilityId, availId, therapistCustomDateId });
  }

  onNavigateBrightTreeSalesOrderUrl(crmSalesOrderAPPId: string) {
    window.open(
      this.salesOrderBrighttreeURL
        .replace('{{SalesOrderID}}', crmSalesOrderAPPId)
        .replace('{{InternalUserID}}', this.brightreeInternalUserId.toString()),
      '_blank'
    );
  }
  onNavigateBrightTreePatientUrl(crmPatientId: string) {
    window.open(
      this.patientBrighttreeURL
        .replace('{{PatientKey}}', crmPatientId)
        .replace('{{InternalUserID}}', this.brightreeInternalUserId.toString()),
      '_blank'
    );
  }

  showAvail(id: any) { this.router.navigate(['/admin/calendar/view-therapist-availability-v1/' + id]); }

  processResult<T>(result: ResultOfT<T>, onSuccess: () => void = null, onError: () => void = null) {
    if (!result) return;
    if (result.isSuccess) { if (onSuccess) onSuccess(); } else { if (onError) onError(); }
  }

  getDayColumnWidth(eventRowContainer: HTMLElement): number {
    return Math.floor(eventRowContainer.offsetWidth / this.users.length);
  }
  getcalenderColumnWidth(): number {
    return Math.floor(this.calendarWidth * this.users.length);
  }

  dragMove(dayEvent: WeekViewTimeEvent, dragEvent: DragMoveEvent) {
    if (this.snapDraggedEvents) {
      const newUser = this.getDraggedUserColumn(dayEvent, dragEvent.x);
      const newEventTimes = this.getDragMovedEventTimes(dayEvent, { ...dragEvent, x: 0 }, this.dayColumnWidth, true);
      const orig = dayEvent.event;
      orig.meta.appointmentInfoReponseModel.field = newUser.id.toString();
      const adjusted = { ...orig, ...newEventTimes, meta: { ...orig.meta, user: newUser } };
      this.restoreOriginalEvents(
        this.events.map((e) => (e === orig ? adjusted : e)),
        new Map([[adjusted, orig]])
      );
    }
    this.dragAlreadyMoved = true;
  }

  dragEnded(weekEvent: WeekViewTimeEvent, dragEndEvent: DragEndEvent, dayWidth: number, useY = false) {
    super.dragEnded(weekEvent, { ...dragEndEvent, x: 0 }, dayWidth, useY);
    this.userChanged.emit({ alredayExist: false, event: weekEvent.event, newUser: this.getDraggedUserColumn(weekEvent, dragEndEvent.x) });
  }

  protected getWeekView(events: CalendarEvent[]) {
    return this.utils.getWeekView({
      events,
      users: this.users,
      viewDate: this.viewDate,
      weekStartsOn: this.weekStartsOn,
      excluded: this.excludeDays,
      precision: this.precision,
      absolutePositionedEvents: true,
      hourSegments: this.hourSegments,
      dayStart: { hour: this.dayStartHour, minute: this.dayStartMinute },
      dayEnd: { hour: this.dayEndHour, minute: this.dayEndMinute },
      segmentHeight: this.hourSegmentHeight,
      weekendDays: this.weekendDays,
      ...getWeekViewPeriod(this.dateAdapter, this.viewDate, this.weekStartsOn, this.excludeDays, this.daysInWeek)
    });
  }

  private getDraggedUserColumn(dayEvent: WeekViewTimeEvent, xPixels: number) {
    const idx = this.view.users.findIndex((u) => u === dayEvent.event.meta.user);
    return this.view.users[idx + Math.round(xPixels / this.dayColumnWidth)];
  }
}